import axiosInstance from "../utils/axiosInstance";

export const fetchSalaryConfigs = async (staffId = null) => {
  const params = staffId ? `?staffId=${staffId}` : "";
  const { data } = await axiosInstance.get(`/staff-salary/configs${params}`);
  return data;
};

export const createSalaryConfig = async (payload) => {
  const { data } = await axiosInstance.post("/staff-salary/configs", payload);
  return data;
};

export const updateSalaryConfig = async (id, payload) => {
  const { data } = await axiosInstance.put(`/staff-salary/configs/${id}`, payload);
  return data;
};

export const deleteSalaryConfig = async (id) => {
  const { data } = await axiosInstance.delete(`/staff-salary/configs/${id}`);
  return data;
};

export const getWorkingDays = async (month, year) => {
  const { data } = await axiosInstance.get(`/staff-salary/working-days?month=${month}&year=${year}`);
  return data;
};

export const calculateSalary = async (month, year, staffId = null) => {
  const params = new URLSearchParams({ month, year });
  if (staffId) params.append("staffId", staffId);
  const { data } = await axiosInstance.post(`/staff-salary/calculate?${params}`);
  return data;
};

export const fetchSalarySlips = async (month = null, year = null, staffId = null) => {
  const params = new URLSearchParams();
  if (month) params.append("month", month);
  if (year) params.append("year", year);
  if (staffId) params.append("staffId", staffId);
  const q = params.toString() ? `?${params}` : "";
  const { data } = await axiosInstance.get(`/staff-salary/slips${q}`);
  return data;
};

export const fetchSalarySlipById = async (id) => {
  const { data } = await axiosInstance.get(`/staff-salary/slips/${id}`);
  return data;
};

export const updateSlipStatus = async (id, status) => {
  const { data } = await axiosInstance.patch(`/staff-salary/slips/${id}/status`, { status });
  return data;
};
